var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6121 4.22553L8.01478 3.67805L6.40666 0.264086C6.36274 0.170614 6.29048 0.0949461 6.20122 0.0489518C5.97736 -0.0667756 5.70532 0.029664 5.59339 0.264086L3.98528 3.67805L0.38791 4.22553C0.288731 4.24036 0.198053 4.28932 0.128627 4.36351C0.0446959 4.45385 -0.00155415 4.57538 3.98784e-05 4.70141C0.0016339 4.82743 0.0509416 4.94764 0.137128 5.03562L2.73987 7.6929L2.12496 11.4451C2.11054 11.5324 2.11976 11.6222 2.15159 11.7043C2.18341 11.7863 2.23655 11.8574 2.305 11.9095C2.37344 11.9616 2.45444 11.9925 2.53882 11.9988C2.6232 12.0051 2.70757 11.9865 2.78238 11.9451L6.00003 10.1736L9.21768 11.9451C9.30553 11.9941 9.40754 12.0104 9.5053 11.9926C9.75183 11.9481 9.9176 11.7033 9.8751 11.4451L9.26019 7.6929L11.8629 5.03562C11.9338 4.96292 11.9805 4.86796 11.9947 4.7641C12.033 4.50446 11.8601 4.2641 11.6121 4.22553Z",
    fill: "#00529C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b408dbb484fb3e353b71654abd6d1967.svg";
export { ForwardRef as ReactComponent };